import LazyLoadImg from "components/LazyLoadImg";
import { FaPlay } from "react-icons/fa";

function TableRowImage({
  executionFunc,
  imgSrc,
  imgAlt,
  imgHeight,
  imgWidth,
  hover,
  isPlaying = false,
}: any) {
  // Overlay appears on hover, or persistently while this track is playing
  const showOverlay = hover || isPlaying;

  return (
    <div
      className="relative overflow-hidden rounded-md"
      style={{ height: imgHeight, width: imgWidth }}
      onClick={executionFunc}
    >
      <LazyLoadImg
        imgSrc={imgSrc}
        imgAlt={imgAlt}
        imgHeight={imgHeight}
        imgWidth={imgWidth}
      />

      {showOverlay && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/50 transition-opacity duration-200">
          {/* While playing: animated bars. On plain hover: play icon */}
          {isPlaying ? (
            <span className="flex h-4 items-end gap-[2px]">
              <span className="eq-bar" style={{ animationDelay: "0s" }} />
              <span className="eq-bar" style={{ animationDelay: "0.2s" }} />
              <span className="eq-bar" style={{ animationDelay: "0.4s" }} />
            </span>
          ) : (
            <FaPlay className="text-sm text-red-600" />
          )}
        </div>
      )}

      {/* Scoped styles for the equalizer animation */}
      <style>{`
        .eq-bar {
          width: 3px;
          height: 100%;
          border-radius: 2px;
          background: #ef4444;
          animation: eqPulse 0.9s ease-in-out infinite;
        }
        @keyframes eqPulse {
          0%, 100% { transform: scaleY(0.3); }
          50% { transform: scaleY(1); }
        }
      `}</style>
    </div>
  );
}

export default TableRowImage;